import { render } from "./ReportCamera.vue?vue&type=template&id=01d445f0"
import script from "./ReportCamera.vue?vue&type=script&lang=js"
export * from "./ReportCamera.vue?vue&type=script&lang=js"
script.render = render

export default script